import React from 'react';
import './Infrastructure.css';

const Infrastructure = () => {
  return (
    <div className="infrastructure-infrastructure">
      <div className="content-infrastructure">
        <h2>Infrastructures</h2>
        <p>Nos expertises en ingénierie électrique et maintenance préventive assurent la fiabilité et la durabilité des infrastructures critiques, notamment dans les bâtiments publics, les réseaux et installations stratégiques.</p>
      </div>
    </div>
  );
};

export default Infrastructure;